<template>
  <div class="meus-dados">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Meus dados</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Veja ou atualize os dados cadastrados na sua conta
          </h5>
        </div>
      </v-container>
    </div>
    <MeusDadosForm />
  </div>
</template>

<script>
import MeusDadosForm from '@/views/MeusDados/MeusDadosForm'

export default {
  name: 'MeusDados',
  components: {
    MeusDadosForm
  }
}
</script>
